import UpstartLoanStatus from './UpstartDealerLoanStatus';

export default UpstartLoanStatus;
